import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names with proper Tailwind CSS class precedence
 * This ensures that later classes properly override earlier ones
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
